import InputType from "common/form/InputType";
import { Form, Input } from "decorator-form";
import ButtonSelect from "common/form/widgets/common/ButtonSelect";
const typeSelect = ButtonSelect.registerWithOptions([
	{value: 'article', label: "Article"},
	{value: 'Product', label: "Product"},
	{value: '', label: "All"}
]);
@Form({title: "Contributor Panel Config"})
export class ContributorPanelConfig {

	@Input({type: InputType.CHECKBOX, title: "minimal"})
	public minimal?: boolean;

	@Input({type: InputType.CHECKBOX, title: "open on key down"})
	public openOnKeyDown?: boolean;

	@Input({type: InputType.CHECKBOX, title: "fill"})
	public fill?: boolean;

	@Input({type: InputType.CHECKBOX, title: "reset on select"})
	public reset?: boolean;

	@Input({type: InputType.CHECKBOX, title: "minimal tag style"})
	public tagMinimal?: boolean;

	@Input({type: typeSelect, title: "Contributor Selection"})
	public CategorySelection?: 'article' | 'product' | 'all';

}



// WEBPACK FOOTER //
// ./src/panels/contributor/ContributorPanelConfig.ts